<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="text"> </p>
<p class="text"> </p>
<p class="text">She lives to help, to fix, to advise, to cheer, to uplift, to
  encourage, to feed, to humor, to heal. She’s a friend, a
  therapist, a nurse, a guide, a saint.</p>
<p class="text">Everyone, but everyone, loves my mom.</p>
<p class="text">Me, she drives crazy.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom009.vue?7278d1bd